<template>
  <div class="component-aceite">
    <div class="aceite-text bg-white rounded rounded-lg">
      <embed
        v-if="file"
        :src="file"
        width="100%"
        height="550"
        type="application/pdf"
        frameborder="0"
      />
      <textarea v-else readonly v-model="termo" />
    </div>
    <div class="form-check mt-3 py-3 px-4">
      <input
        class="form-check-input"
        type="checkbox"
        v-model="checkAceite"
        value="1"
        id="defaultCheck1"
      />
      <label class="form-check-label" for="defaultCheck1">
        {{ aceite }}
      </label>
    </div>
    <div class="row align-items-center mt-4">
      <div class="col-md-3 col-lg-2">
        <Botao
          v-if="voltar && linkVoltar"
          title="Voltar"
          :link="linkVoltar"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
        <Botao
          v-if="actionVoltar"
          title="Voltar"
          @click="fechar"
          nameClass="btn btn-outline-secondary btn-lg btn-block"
          >VOLTAR</Botao
        >
      </div>
      <div class="col-md-4 col-lg-4 mt-3 mt-md-0">
        <Botao
          v-if="linkAceite"
          title="Confirmar Aceite"
          :class="{ disabled: !checkAceite }"
          :link="checkAceite ? linkAceite : ''"
          nameClass="btn btn-success btn-lg btn-block"
          >{{ descButton }}</Botao
        >
        <Botao
          v-if="actionAceite"
          title="Confirmar Aceite"
          :class="{ disabled: !checkAceite || loading }"
          @click="checkAceite && !loading ? salvarAceite() : ''"
          nameClass="btn btn-success btn-lg btn-block"
        >
          <span
            class="spinner-grow spinner-grow-sm pr-2"
            role="status"
            aria-hidden="true"
            v-show="loading"
          ></span>
          <span v-if="loading">{{ strLoading }}</span>
          <span v-else>{{ descButton }}</span>
        </Botao>
      </div>
    </div>
  </div>
</template>
<script>
import Botao from "@/components/botoes/Botao.vue";

export default {
  name: "Aceite",
  props: {
    voltar: {
      type: Boolean,
      default: false,
    },
    linkVoltar: {
      type: String,
      default: "",
    },
    linkAceite: {
      type: String,
      default: "",
    },
    actionAceite: {
      type: Boolean,
      default: false,
    },
    actionVoltar: {
      type: Boolean,
      default: false,
    },
    termo: {
      type: String,
      default: "",
    },
    aceite: {
      type: String,
      default: "Aceito os termos acima citados.",
    },
    loading: {
      type: Boolean,
      default: false,
    },
    strLoading: {
      type: String,
      default: "Aguarde, enviando o aceite",
    },
    file: {
      type: String,
      default: "",
    },
    descButton: {
      type: String,
      default: "CONFIRMAR ACEITE",
    },
  },
  data() {
    return {
      checkAceite: false,
    };
  },
  components: {
    Botao,
  },
  methods: {
    salvarAceite() {
      this.$emit("click", {
        checkAceite: this.checkAceite,
      });
    },
    fechar() {
      this.$emit("fechar");
    },
  },
};
</script>
<style lang="scss" scoped>
.aceite-text {
  max-width: 1200px;
  min-height: 61vh;
  padding: 10px 12px 14px 10px;
}
textarea {
  width: 100%;
  height: 100%;
  border: none;
  font-size: 14px;
  line-height: 1.4;
  text-align: left;
  color: #6c757d;
  padding: 10px;
}
.form-check-input {
  margin-top: 0.07rem;
}
.form-check-label {
  font-weight: normal;
  font-size: 15px;
  text-align: left;
  color: #212529;
}
</style>
